'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'pricing-pages-unified-ui/reducers'; //import { routerMiddleware } from 'react-router-redux';

import sentryMiddleware from 'pricing-pages-unified-ui/utils/sentryMiddleware'; //const middleware = [thunk, routerMiddleware(browserHistory)];

const middleware = [thunk, sentryMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(...middleware))(createStore);
const initialState = {};
const store = createStoreWithMiddleware(rootReducer, initialState);
export default store;